export default __webpack_public_path__ + "static/media/lccx.af494aaa.jpg";